import { BreakpointsOptions } from '@mui/material';

const breakpointsOptions: BreakpointsOptions = {
  values: {
    xs: 10,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

export default breakpointsOptions;
